export default class DateExtensions {}
/**
 * The formatDateFromStringTimestamp function takes an timestamp in a string format
 * as '1688009760000' and returns the date in a mm/dd/yyyy format
 * @param stringTimestamp string timestamp
 */
Object.defineProperty(DateExtensions, "formatDateFromStringTimestamp", { value: dateString => {
  const date = new Date(dateString);
  const formattedDate = date.toLocaleDateString('en-US', {
    month: '2-digit',
    day: '2-digit',
    year: 'numeric'
  });
  return formattedDate;
}});